<template>
	<div class="modal modal-form-task is-active">
		<div class="modal-background"></div>
		<div class="modal-card">
			<header class="modal-card-head">
				<p class="modal-card-title" v-if="item">Editar Tarefa</p>
				<p class="modal-card-title" v-if="!item">Adicionar Tarefa</p>
				<button class="delete" aria-label="close" @click="goBack"></button>
			</header>
			<form @submit.prevent="onSubmit()">

				<section class="modal-card-body" >
					<div class="field">
						<div class="control">
							<input class="input" type="text" v-model="name" required placeholder="Nome">
						</div>
					</div>
					<div class="field">
						<div class="control">
							<textarea class="input textarea" v-model="description" placeholder="Descrição"></textarea>
						</div>
					</div>

					<hr>

					<div class="field category-color-options">
						<h4>Escolha a cor de fundo</h4>
						<div class="field has-addons ">

							<label><input type="radio" v-model="theme" value="40ff00"><span style="background-color:#40ff00"></span></label>
							<label><input type="radio" v-model="theme" value="ffff00"><span style="background-color:#ffff00"></span></label>
							<label><input type="radio" v-model="theme" value="ff9933"><span style="background-color:#ff9933"></span></label>
							<label><input type="radio" v-model="theme" value="ff4000"><span style="background-color:#ff4000"></span></label>

						</div>
					</div>

					<hr>

					<div class="field">
						<h4>Atribuir data e hora</h4>
						<div class="field has-addons ">
							<label class="task-due" @click.stop @mousedown.stop>
								<i><svg viewBox="0 0 24 24"><path fill="#000000" d="M19,19H5V8H19M16,1V3H8V1H6V3H5C3.89,3 3,3.89 3,5V19A2,2 0 0,0 5,21H19A2,2 0 0,0 21,19V5C21,3.89 20.1,3 19,3H18V1M17,12H12V17H17V12Z" /></svg></i>
								<span v-if="due">{{ formatDue(due) }}</span>
								<div @click.stop.prevent @mousedown.stop.prevent>
									<datetime v-model="due" value-zone="local" type="datetime" :minute-step="5" auto title="Selecionar data" :phrases="{ok: 'Ok', cancel: 'Cancelar'}"></datetime>
								</div>
							</label>
						</div>
					</div>


				</section>

				<footer class="modal-card-foot">
					<button type="submit" class="button is-success">Salvar</button>
					<button class="button" @click.prevent="goBack">Cancel</button>
					<button v-if="item" class="button is-danger" @click.prevent="onDelete">Excluir</button>
				</footer>

			</form>
		</div>
	</div>
</template>


<script>

import firebase from '@/firebase'
import { Datetime } from 'vue-datetime';
export default {
	props:['item'],
	components: {
		datetime: Datetime
	},
	data() {
		return {
			name: '',
			description: '',
			theme:'00FFFF',
			due:null,
		}
	},
	computed: {
		userId() {
			return this.$store.getters.userId;
		},
	},
	methods:{
		goBack(){
			this.$router.push({name:'home'});
		},
		onSubmit(){

			var data = {
				name:this.name,
				description:this.description,
				due:this.due,
			};
			if(!data.due) data.due = null; // in case is undefined
			
			if(this.theme) data.theme = this.theme;

			if(this.item){
				this.$store.dispatch('updateTask',{task_id:this.item.id,data:data});
			} else {
				data.done = false;
				this.$store.dispatch('addTask',{data:data});
			}

			//popup para registrar usuário anonimo
			if(askRegisterAnonymous(this.$store.state)) {
				this.$router.push({name:'formRegistrar'});
				return;
			}


			this.goBack();
		},
		onDelete(){
			if(!confirm('Tem certeza?')) return;
			this.$store.dispatch('deleteTask',{task_id:this.item.id});
			this.goBack();
		},
		formatDue(datetime){
			if(!datetime) return datetime;
			var date = new Date(datetime);
			var val = {
				h: date.getHours(),
				i: date.getMinutes(),
				d: date.getUTCDate(),
				m: date.getUTCMonth() + 1,
				yy: date.getUTCFullYear().toString().substring(2),
				yyyy: date.getUTCFullYear()
			}
			val.mm = (val.m < 10 ? '0' : '') + val.m;
			val.dd = (val.d < 10 ? '0' : '') + val.d;
			val.hh = (val.h < 10 ? '0' : '') + val.h;
			val.ii = (val.i < 10 ? '0' : '') + val.i;

			return val.dd+'/'+val.mm+' '+val.hh+':'+val.ii;
		},



	},
	mounted() {
		if(this.item){
			this.name = this.item.name;
			this.description = this.item.description;
			this.theme = this.item.theme;
			this.due = this.item.due;
		}
	},
};
</script>


<style>

.modal-form-task hr { 
	background-color: #dbdbdb;
	margin:15px 0;
	height:1px;
}

body.is-mobile .modal-form-task .task-due, .modal-form-task .task-due { 
	font-size:16px;
}
</style>
